// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const SearchIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
          <path fill="inherit" d="M87.533 80.03l-24.59-24.59c3.323-4.588 5.31-10.208 5.31-16.296 0-.312-.042-.61-.09-.908.05-.3.092-.605.092-.922 0-15.36-12.497-27.857-27.857-27.857-.273 0-.536.043-.8.08-.264-.037-.525-.08-.798-.08-15.36 0-27.858 12.497-27.858 27.857 0 .312.042.61.092.91-.05.3-.093.603-.093.92 0 15.36 12.497 27.858 27.858 27.858.273 0 .535-.043.8-.08.263.037.524.08.798.08 5.208 0 10.07-1.464 14.245-3.963l24.942 24.94c1.1 1.1 2.537 1.647 3.976 1.647 1.44 0 2.88-.55 3.976-1.647 2.195-2.195 2.195-5.754 0-7.95zM39.598 55.838c-.265-.038-.526-.08-.8-.08-9.16 0-16.612-7.453-16.612-16.613 0-.312-.042-.61-.092-.908.05-.3.093-.605.093-.922 0-9.16 7.453-16.612 16.613-16.612.272 0 .534-.042.8-.08.262.038.524.08.798.08 9.16 0 16.612 7.452 16.612 16.612 0 .312.043.61.092.91-.05.3-.094.603-.094.92 0 9.16-7.452 16.612-16.612 16.612-.274 0-.536.043-.798.08z"/>
        </svg>
      )
    }
  </Icon>
);

export default SearchIcon;
